import {
  SessionLinkMethodType,
  SessionLinkType,
} from '@energy-retailer/constants';
import { z } from 'zod';

const linkSchema = z.object({
  href: z.string(),
  rel: z.nativeEnum(SessionLinkType),
  method: z.nativeEnum(SessionLinkMethodType),
});

export const windcaveCreateSessionSchema = z
  .object({
    id: z.string(),
    links: z.array(linkSchema),
    expiryDate: z.string(),
  })
  .transform((data) => {
    const hpp = data.links.find(({ rel }) => rel === SessionLinkType.Hpp);

    return {
      id: data.id,
      href: hpp?.href,
      expiryDate: data.expiryDate,
    };
  });

export type WindcaveCreateSessionSchema = z.input<
  typeof windcaveCreateSessionSchema
>;

export type ParsedWindcaveCreateSessionSchema = z.output<
  typeof windcaveCreateSessionSchema
>;
